import React, { useEffect, useState } from "react";

import Modal from "components/modal";

import PartySelectorView from "../partySelectorView/partySelectorView";

import styles from "./partySelector.scss";
import Button from "components/button";
import { PARTY_AGGREGATION_LEVEL, PROFILE_TYPES } from "constants/common";
import { requirePartyId } from "utils/partyIdUtils";

const {
  party_selector_trigger_title,
  party_selector_account,
  party_selector_trigger,
  party_selector_modal,
  party_action_footer,
  party_account_name,
  disabled,
  icon,
} = styles;

const PartySelector = ({
  partyDetails,
  product,
  lobDetails,
  lobFromUrl,
  onSelectAccount,
  isOpenByDefault,
  aggregationLevel: partyAggregationLevel,
  showRaiseSrButton,
  source,
  user,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const [selectedParty, setSelectedParty] = useState({ ...partyDetails });

  const isAtbSkam = user === PROFILE_TYPES.ATB_SECONDARY_KAM_USER;

  useEffect(() => {
    setIsOpen(isOpenByDefault);
  }, [isOpenByDefault]);

  useEffect(() => {
    setSelectedParty({ ...partyDetails });
  }, [partyDetails]);

  const isCloseDisabled = (() => {
    if (isAtbSkam) {
      return false;
    }
    return partyAggregationLevel === PARTY_AGGREGATION_LEVEL.PARTY && !partyDetails?.partyId ? true : !partyDetails;
  })();

  const isViewAccountDisabled =
    partyAggregationLevel === PARTY_AGGREGATION_LEVEL.PARTY && !selectedParty?.partyId ? true : !selectedParty;

  const isPartySelectorDisabled = () => {
    return partyAggregationLevel === PARTY_AGGREGATION_LEVEL.EMAIL || requirePartyId(lobDetails?.key) ? "" : disabled;
  };

  const closePartySelector = (value) => {
    setIsOpen(value);
  };

  const handleTriggerOnClick = () => {
    if (!partyDetails) {
      return;
    }
    setIsOpen(true);
  };

  const handleViewAccountClick = () => {
    setSelectedParty(selectedParty);
    onSelectAccount(product ? { ...selectedParty, product } : selectedParty);
    closePartySelector();
  };

  const getPartyAccountName = () => {
    if (partyDetails.partyName || partyAggregationLevel === PARTY_AGGREGATION_LEVEL.PARTY) {
      return partyDetails.partyName;
    } else if (partyAggregationLevel === PARTY_AGGREGATION_LEVEL.PRODUCT) {
      return "All " + product + " Accounts";
    } else if (partyAggregationLevel === PARTY_AGGREGATION_LEVEL.LOB) {
      return "All " + lobDetails.displayName + " Accounts";
    } else if (partyAggregationLevel === PARTY_AGGREGATION_LEVEL.EMAIL) {
      return "All Accounts";
    }
  };

  return (
    <div className={party_selector_account}>
      <div className={party_selector_trigger_title}>Account(s)</div>
      <div className={`${party_selector_trigger} ${isPartySelectorDisabled()}`} onClick={handleTriggerOnClick}>
        <span className={party_account_name}>{getPartyAccountName()}</span>
        <div className={icon}>
          <i className="arrowdown"></i>
        </div>
      </div>
      <div className={party_selector_modal}>
        {isOpen && (
          <Modal
            variant={"FULL_SCREEN"}
            header={"Select Account"}
            body={
              <PartySelectorView
                {...{
                  ...partyDetails,
                  lobDetails,
                  lobFromUrl,
                  product,
                  selectedParty,
                  setSelectedParty,
                  closePartySelector,
                  partyAggregationLevel,
                  showRaiseSrButton,
                  source,
                  user,
                  onSelectAccount,
                }}
              />
            }
            footer={
              isAtbSkam ? null : (
                <div className={party_action_footer}>
                  <Button displayName="Select Account" disabled={isViewAccountDisabled} onClick={handleViewAccountClick} />
                </div>
              )
            }
            showCloseButton={!isCloseDisabled}
            onCloseClick={() => closePartySelector(isCloseDisabled)}
          />
        )}
      </div>
    </div>
  );
};

export default PartySelector;
